import VaRPanel from "@/components/risk/VaRPanel";
import RiskLensesPanel from "@/components/risk/RiskLensesPanel";

export default function PVaR() {
  return (
    <div className="space-y-6">
      <VaRPanel range="P" />
      <RiskLensesPanel range="P" />
    </div>
  );
}
